module.exports = __webpack_public_path__ + "img/arrow.cfbc6c30.png";